import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import AppointmentService from '../utils/AppointmentService.js';
import CreateAccount from './CreateAccount.js';
import { Switch, Route, Link } from 'react-router-dom'
import Modal from 'react-modal';
var parser = require('parse-address');


// if (!window.Promise) {
//   window.Promise = Promise;
// }
class CustomerInfoForm extends Component {

  constructor(props) {
    super(props);
    this.Appt = new AppointmentService()

    this.state = {
      phone: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      new_email: '',
      formError: '',
      password: '',
      password_confirm: '',
      openLogin:false,
      login_password: '',
      loginError: this.props.loginError
    };
    this.loginUser = this.loginUser.bind(this)
  }


  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0;
  }
  componentWillMount(){
  }
  componentWillReceiveProps(props){
    this.setState({
      loginError: props.loginError
    })
    // if(props.user){
    //   this.setState({
    //     phone: props.user.phone_number,
    //     first_name: props.user.first_name,
    //     last_name: props.user.last_name,
    //   })
    // }
  }
  handleChange = event => {
      this.setState({
        [event.target.id]: event.target.value
      });
  }
  closeModal = () => {
    this.setState({
      openLogin: false
    })
  }
  handleSubmit = event =>  {
    event.preventDefault()
    if(!this.state.first_name){
      this.setState({
        formError: "Please enter a first name"
      })
    }
    else if (!this.state.last_name) {
      this.setState({
        formError: "Please enter a last name"
      })
    }
    else if (!this.state.phone_number) {
      this.setState({
        formError: "Please enter a phone number"
      })
    }
    else if(!this.props.user || !this.props.user.email){
      this.setState({
        formError: "Please enter an email"
      })
    }
    else if (this.props.user && this.props.user.email && this.props.user.email.includes("@genericuser.getspiffy.com") && !this.state.new_email) {
      this.setState({
        formError: "Please enter an email"
      })
    }
    else if (this.props.user.email.includes("@genericuser.getspiffy.com") && (!this.state.password || !this.state.password_confirm)) {
      this.setState({
        formError: "Please enter a password"
      })

    }
    else if (this.state.password != this.state.password_confirm){
      this.setState({
        formError: "Passwords must match"
      })
    }
    else{
      this.setState({
        formError: ""
      })
      var email = this.state.new_email
      if(!email || email.length < 1){
        email = this.props.user.email
      }
      this.Appt.updateUser(this.state.first_name, this.state.last_name, email, this.state.phone_number, this.state.password)
             .then(res =>{
               if(res.errors && res.errors.includes('Email has already been taken')){
                 this.setState({
                   openLogin:true
                 })
                }
                else if(res.errors){
                  throw new Error("Error besides email taken")
                  this.setState({
                    formError: res.errors
                  })
                }
                else if(res){
                    this.props.saveUser(res.user)
                }
               else {
                 this.setState({
                 formError: "Your information could not be saved"
                })
               }
             })
             .catch(err =>{
               this.setState({
                 formError: "Your information could not be saved"
              })
             })
      //this.props.saveUser()
    }
  }
  loginUser() {
    if(this.state.new_email){
      this.props.loginUser(this.state.new_email, this.state.login_password)
    }
    else {
      throw new Error("Tried Logging in with email missing" + JSON.stringify(this.props.user))
      this.setState({
        formError: "Email is missing"
      })
    }
  }

    render(){
      const modalStyle2 =
      this.state.width < 780 ?
      {
        content: {
          top                   : '25%',
          left                  : '0%',
          height                : '50%',
          width                 : '100%',
          padding               : '0px',
          right                 : 'auto',
          backgroundColor       : 'white',
          color                 : 'black',
        }
      }:
        {
          content: {
            top                   : '25%',
            left                  : '35%',
            height                : '60%',
            width                 : '35%',
            padding               : '0px',
            right                 : 'auto',
            backgroundColor       : 'white',
            color                 : 'black',
          }
        }

      return (
              <div>
              <div className="card-header blue-background text-white text-center dateTimeContainer ">
                Please Enter Missing Info
              </div>
                <p className="redText">{this.state.formError}</p>
                <form className="infoForm" onSubmit={this.handleSubmit}>
                { this.props.user && this.props.user.email && this.props.user.email.includes("@genericuser.getspiffy.com") &&
                  <div className="form-group ">
                    <input className="form-control" type="text" id="new_email" value={this.state.new_email} onChange={this.handleChange} placeholder="Email" ></input>
                  </div>
                }
                    <div className="form-group ">
                      <input className="form-control" type="text" id="first_name" value={this.state.first_name} onChange={this.handleChange} placeholder="First Name" ></input>
                    </div>
                    <div className="form-group">
                      <input className="form-control" type="text" id="last_name" value={this.state.last_name} onChange={this.handleChange} placeholder="Last Name"></input>
                    </div>
                  <div className="form-row mb-3">
                      <div className="col">
                        <input className="form-control" type="text" id="phone_number" value={this.state.phone_number} onChange={this.handleChange} placeholder="Phone Number"></input>
                      </div>
                  </div>
                  <div className="form-row mb-3">
                      <div className="col">
                        <input className="form-control" type="password" id="password" value={this.state.password} onChange={this.handleChange} placeholder="Password"></input>
                      </div>
                      <div className="col">
                        <input className="form-control" type="password" id="password_confirm" value={this.state.password_confirm} onChange={this.handleChange} placeholder="Confirm Password"></input>
                      </div>
                  </div>
                  <div className="form-group">
                    <button className="btn btn-success margin-top btn-block text-center" type="submit">Confirm Info</button>
                  </div>
                </form>
                <Modal
                  style={modalStyle2}
                  isOpen={this.state.openLogin}
                  contentLabel="Example Modal">
                  <div className="card-header blue-background text-white text-center dateTimeContainer ">
                    Login
                  </div>
                  <p className="paddingTen">There is already an account associated with this email. If you know it, you may login now, or register with a different email.</p>
                  <p className="paddingTen redText">{this.props.error}</p>
                  <p className="paddingTen">{this.state.new_email}</p>
                  <div className="col">
                    <input className="form-control" type="password" id="login_password" value={this.state.login_password} onChange={this.handleChange} placeholder="Password"></input>
                  </div>
                  <button className="btn btn-success btn-block text-center" type="submit" onClick={this.loginUser}>Login</button>
                  <button className="btn btn-close btn-block text-center" type="submit" onClick={this.closeModal}>Close</button>
                </Modal>
              </div>
              )
    }
}
export default CustomerInfoForm;



// WEBPACK FOOTER //
// ./src/Components/CustomerInfoForm.js